import { useQuery } from '@tanstack/react-query';
import type { Coverage } from '@ametica/shared';
import { api } from './client';
import { SITES_KEY } from './sites';

/** Panel pokrytia naprieč stránkami. Obnovuje sa s prehľadom — sken na pozadí mení inventár. */
export function useCoverage() {
  return useQuery({ queryKey: ['coverage'], queryFn: () => api<Coverage>('/coverage'), refetchInterval: 60_000 });
}

export function useSiteCoverage(id: string) {
  return useQuery({ queryKey: [...SITES_KEY, id, 'coverage'], queryFn: () => api<Coverage>(`/sites/${id}/coverage`) });
}
